import React from 'react';
import { Activity } from 'lucide-react';
import { computeDelta, deltaColor } from './analyticsHelpers';

const cardStyle = {
  background: '#FFFFFF',
  borderRadius: 18,
  padding: 14,
  border: '1px solid rgba(112, 63, 246, 0.08)',
  boxShadow: 'var(--premium-shadow-nested)',
  flex: 1,
  minWidth: 160,
};

const Stat = ({ label, value, prev, testId }) => {
  const delta = computeDelta(value, prev);
  return (
    <div style={cardStyle} data-testid={testId}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <Activity size={14} color="var(--accent-purple-strong)" />
        <p style={{ margin: 0, fontSize: 11, color: '#999', letterSpacing: 1, textTransform: 'uppercase', fontWeight: 700 }}>{label}</p>
      </div>
      <p style={{ margin: 0, fontSize: 28, fontWeight: 700, color: '#111', lineHeight: 1 }}>{value || 0}</p>
      <p style={{ margin: '6px 0 0', fontSize: 11, color: deltaColor(delta), fontWeight: 700 }}>
        {delta.label} vs previous
      </p>
    </div>
  );
};

export const ActiveUsersCards = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="active-users-section" style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      <Stat label="DAU · Last 24h" value={data.dau} prev={data.prev_dau} testId="active-users-dau" />
      <Stat label="WAU · Last 7 days" value={data.wau} prev={data.prev_wau} testId="active-users-wau" />
      <Stat label="MAU · Last 30 days" value={data.mau} prev={data.prev_mau} testId="active-users-mau" />
    </div>
  );
};
